<template>
  <section class="px-md-12 mx-md-5">
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto" class="ml-auto">
          <v-text-field
            filled
            rounded
            dense
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1">
      <!-- NO TOCAR. ESTA PAGINACIÓN POR SERVIDOR SI FUNCIONA -->
      <v-data-table
        :headers="headers"
        :items="assistanceListHistory"
        :search="search"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar
                  size="40"
                  :color="
                    $vuetify.theme.dark
                      ? 'blue-grey darken-4'
                      : 'blue-grey lighten-5'
                  "
                >
                  <v-img
                    v-if="item.url_image"
                    :src="item.url_image"
                    alt="Avatar del usuario"
                  ></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.id`]="{ item }">
          {{ item.assistance[item.assistance.length - 1].created_at }}
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip top color="blue-grey">
            <template v-slot:activator="{ on }">
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'accent' : 'blue-grey'"
                  @click.stop="dialogAssistance(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </v-hover>
            </template>
            <span>Ver asistencias</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-row justify="end">
            <v-col cols="auto">
                <v-pagination
                    v-if="!isLoading && assistanceListHistory.length > 0"
                    circle
                    color="primary"
                    v-model="page"
                    :length="pageCount"
                ></v-pagination>
            </v-col>
        </v-row> -->

    <!-- Modal nivel 1 -->
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" persistent scrollable width="500">
          <v-card>
            <v-card-title class="pa-0 shadow-1">
              <v-img
                :src="require('@/assets/illustrations/bg_modal_card.svg')"
                cover
                position="left bottom"
                class="align-center"
                height="65px"
              >
                <v-card-title class="font-weight-medium primary--text">
                  Asistencias de {{ agent }}
                </v-card-title>
              </v-img>
            </v-card-title>

            <vuescroll
              :ops="{
                bar: { background: '#bacfcec0', keepShow: true },
              }"
            >
              <v-card-text style="max-height: 600px">
                <v-text-field
                  filled
                  rounded
                  dense
                  v-model="searchAgent"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
                <br />
                <v-data-table
                  :headers="headersAgent"
                  :items="desserts"
                  :search="searchAgent"
                  :items-per-page="15"
                  hide-default-footer
                  :page.sync="page"
                  @page-count="pageCount = $event"
                >
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip top color="blue-grey">
                      <template v-slot:activator="{ on }">
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            v-on="on"
                            text
                            icon
                            :color="hover ? 'accent' : 'blue-grey'"
                            @click.stop="dialogAssistance2(item.id)"
                          >
                            <v-icon>mdi-eye</v-icon>
                          </v-btn>
                        </v-hover>
                      </template>
                      <span>Ver detalles</span>
                    </v-tooltip>
                  </template>
                </v-data-table>

                <v-row justify="end">
                  <v-col cols="auto">
                    <v-pagination
                      circle
                      color="primary"
                      v-model="page"
                      :length="pageCount"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-card-text>
            </vuescroll>

            <v-divider></v-divider>

            <v-card-actions class="mx-2">
              <v-spacer></v-spacer>
              <v-hover v-slot:default="{ hover }">
                <v-btn
                  text
                  rounded
                  class="mr-1"
                  :color="hover ? 'error' : 'grey'"
                  @click="dialog = false"
                  >Cerrar</v-btn
                >
              </v-hover>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <!-- Modal nivel 2 -->
    <nivel2Dialog
      v-if="dialog2"
      :isActive="dialog2"
      :id="idDetails"
      @dialog:close="closeDialogAssistance2"
    ></nivel2Dialog>
  </section>
</template>

<script>
import vuescroll from "vuescroll";
import nivel2Dialog from "./dialogs/nivel2Dialog.vue";

export default {
  components: {
    vuescroll,
    nivel2Dialog,
  },

  data() {
    return {
      isLoading: false,
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      search: "",
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary--text",
          width: "35%",
        },
        {
          text: "Última asistencia",
          value: "id",
          class: "primary--text",
          width: "50%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      headersAgent: [
        {
          text: "Duración de jornada",
          value: "hours_worked",
          class: "primary--text",
          width: "50%",
        },
        {
          text: "Fecha",
          value: "created_at",
          class: "primary--text",
          width: "50%",
          align: "right",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "center",
          sortable: false,
        },
      ],
      page: 1,
      pageCount: 0,
      desserts: [],
      dialog: false,
      dialog2: false,
      agent: "",
      searchAgent: "",
      idDetails: null,
    };
  },
  computed: {
    assistanceListHistory() {
      return this.$store.getters["assistance/GET_ASSISTANCE_AGENT_HISTORY"];
    },
  },

  watch: {
    options: {
      handler() {
        this.assistanceGet();
      },
      deep: true,
    },
  },

  created() {
    this.assistanceGet();
  },

  methods: {
    async assistanceGet() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      const payload = {
        page,
        itemsPerPage,
      };

      try {
        const res = await this.$store.dispatch(
          "assistance/GET_HISTORY",
          payload
        );
        // console.log(res);
        this.pageCount = res.last_page;
        this.totalItems = res.total;
      } catch (error) {
        this.$snotify.error("Hubo un error en la consulta.", "Error");
        // console.log(error);
      }
      this.isLoading = false;
    },
    statusColor(status) {
      switch (status) {
        case 1:
          return "success";
        case 2:
          return "grey";
        default:
          return "grey";
      }
    },
    dialogAssistance(value) {
      this.dialog = true;
      this.desserts = value.assistance;
      this.agent = value.name;
    },

    dialogAssistance2(value) {
      this.idDetails = value;

      this.dialog2 = true;
    },

    async closeDialogAssistance2(value) {
      this.dialog2 = false;
    },
  },
};
</script>
